import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { toggleContentBlockContent } from '../../consts/nodes';
import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class ToggleContent extends BaseExtension {
  get schema(): NodeSpec {
    return {
      content: toggleContentBlockContent,
      defining: true,
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  plugins = plugins;
}
